'use strict';

import { SALES } from './Sales';
import { SALES_PME as SALES_PME_PERMISSION_GROUPS } from '../PermissionsGroups';

const sales_pme_permissions_list = [];

for (const [key, value] of Object.entries(SALES_PME_PERMISSION_GROUPS)) {
  sales_pme_permissions_list.push({
    action_list: value,
    element: key,
  });
}

const SALES_PME = {
  can: [
    ...SALES.can,
    ...sales_pme_permissions_list,
  ],
};

export {
  SALES_PME,
};
